import { AppState } from '../store'
import { Sort } from '../types/Sort'

export const sortSelector = (state: AppState): Sort => state?.sort ?? {}
